import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

const ThemeContext = createContext(null);

const STORAGE_KEY = "rayabot-client-theme"; // "light" | "dark"

const getSystemPreference = () => {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

const readStoredTheme = () => {
  if (typeof window === "undefined") return null;
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === "dark" || saved === "light" ? saved : null;
};

const applyThemeClass = (theme) => {
  const root = document.documentElement;
  if (theme === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
};

const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(
    () => readStoredTheme() || getSystemPreference()
  );

  // اعمال کلاس روی <html> هر بار که تم عوض میشه
  useEffect(() => {
    applyThemeClass(theme);
  }, [theme]);

  // اگه کاربر هیچ‌وقت دستی انتخاب نکرده بود، تغییر ترجیح سیستم رو دنبال کن
  useEffect(() => {
    if (readStoredTheme()) return; // کاربر دستی انتخاب کرده، دیگه گوش نده

    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      setThemeState(e.matches ? "dark" : "light");
    };

    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const setTheme = useCallback((next) => {
    setThemeState(next);
    localStorage.setItem(STORAGE_KEY, next);
  }, []);

  const toggleTheme = useCallback(() => {
    setThemeState((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

const useTheme = () => useContext(ThemeContext);

export { ThemeProvider, useTheme };